<template>
  <div>
    <Frontendlayout>
      <section class="hero_in contacts">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Merchant Signup</h1>
          </div>
        </div>
      </section>
      <div class="bg_color_1">
        <div class="container margin_80_55">
          <div class="row justify-content-between">
            <!--div class="col-lg-4">
              <img
                src="../../public/frontend/img/vendor-icon-1.jpg"
                width="100%"
              />
              
            </div-->
            <div class="col-lg-12">
              <!-- <h4>Merchant Signup</h4>
              <p>Connect with us to increase your client reach</p>
              <div id="message-contact"></div> -->
              <form
                @submit.prevent="register()"
                action="/register"
                id="vendor-registration-form"
                autocomplete="off"
              >
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Your Name</label>
                      <input class="form-control" v-model="name" type="text" />
                      <!-- <i class="ti-user"></i> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Shop Name</label>
                      <input
                        class="form-control"
                        v-model="company_name"
                        type="text"
                      />
                      <!-- <i class="ti-user"></i> -->
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Your Email</label>
                      <input
                        class="form-control"
                        v-model="email"
                        type="email"
                      />
                      <!-- <i class="icon_mail_alt"></i> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Your Phone</label>
                      <input
                        class="form-control"
                        v-model="phone_no"
                        type="text"
                      />
                      <!-- <i class="icon-mobile"></i> -->
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Your password</label>
                      <input
                        class="form-control"
                        type="password"
                        v-model="password"
                        id="password1"
                      />
                      <!-- <i class="icon_lock_alt"></i> -->
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Confirm password</label>
                      <input
                        class="form-control"
                        type="password"
                        v-model="password_confirm"
                        id="password2"
                      />
                      <!-- <i class="icon_lock_alt"></i> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>PIN/Localization</label>
                      <vue-simple-suggest
                        v-model="pincode"
                        display-attribute="name"
                        value-attribute="url"
                        :list="getSuggestionList"
                        @select="get($event)"
                      ></vue-simple-suggest>
                      <!-- <i class="icon_lock_alt"></i> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Pan No</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="pan_no"
                        id="pan_no"
                      />
                      <!-- <i class="icon_lock_alt"></i> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>GST No</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="gst_no"
                        id="gst_no"
                      />
                      <!-- <i class="icon_lock_alt"></i> -->
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Your Address (optional)</label>
                  <textarea
                    class="form-control"
                    v-model="address"
                    id="address"
                    style="height: 100px"
                  ></textarea>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Upload Pan Card</label>

                      <input
                        class="form-control"
                        type="file"
                        @change="handlePanFileUpload($event)"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Upload GST Certificate (Optional)</label>

                      <input
                        class="form-control"
                        type="file"
                        @change="handleGstFileUpload($event)"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Are you human? {{ num1 }} + {{ num2 }} =</label>
                      <input
                        class="form-control"
                        type="text"
                        id="verify_captcha"
                        name="verify_captcha"
                        v-model="verify_captcha"
                      />
                    </div>
                  </div>
                </div>
                <center>
                  <button
                    type="submit"
                    class="btn_1 rounded add_top_30"
                    :disabled="loading"
                  >
                    <span
                      v-show="loading"
                      class="spinner-border spinner-border-sm"
                    ></span>
                    Register Now!
                  </button>
                </center>
                <div class="text-center add_top_10">
                  Already have an acccount?
                  <!-- <strong><a href="login.html">Sign In</a></strong> -->
                  <router-link to="/signin"
                    ><strong><a>Sign In!</a></strong></router-link
                  >
                </div>
              </form>
            </div>
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>
      <!-- /bg_color_1 -->
      <!-- /hero_single -->
    </Frontendlayout>
  </div>
</template>

<script>
//import Alert from "../cmps/Alert";
import API from "../services/index";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
//import router from "../routes";
import Frontendlayout from "../layouts/Frontendlayout.vue";

export default {
  data() {
    return {
      name: "",
      company_name: "",
      email: "",
      password: "",
      phone_no: "",
      password_confirm: "",
      role_id: "2",
      msg: null,
      classAlert: null,
      num1: 0,
      num2: 0,
      verify_captcha: "",
      loading: false,
      panFile: null,
      gstFile: null,
      address: "",
      gst_no: "",
      pan_no: "",
      pincode: "",
      geocodes:[]
    };
  },
  beforeMount() {
    this.reloadCaptcha();
  },
  methods: {
    reloadCaptcha() {
      this.num1 = this.getRandomIntInclusive(0, 9);
      //alert(this.num1);
      this.num2 = this.getRandomIntInclusive(0, 9);
      //alert(this.num1 + " " + this.num2);
    },
    getRandomIntInclusive(min, max) {
      //alert("hii");
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
    },

      getSuggestionList() {
      var i = [];
      if (this.pincode.length >= 2) {
        return API.get(`https://location.securebrandtech.com/auto/api?q=${this.pincode}`)
          .then(function (response) {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];
            return uniq;
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
    get(value) {
      var i = [];
      API.get(`https://location.securebrandtech.com/auto/api?q=${value}`)
        .then(function (response) {
          var j =0 ;
          response.data.features.forEach(function (feature) {
            if(j === 0){
            i.push(feature.geometry.coordinates);
            }
           j++;
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      setTimeout(() => {
        this.geocodes = i;
      }, 2000);
    }, 
    register() {
      this.loading = true;
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      if (this.phone_no.length != 10) {
        Toast.fire({
          icon: "Success",
          title: "Phone number must be of 10 digits",
        });
        this.reloadCaptcha();
        this.loading = false;
        return false;
      }
        if(this.geocodes.length == 0){
         Toast.fire({
          icon: "Error",
          title: "Please Select Location List Option ",
        });
        this.loading = false;
        return false;
      }
      if (this.pan_no.length != 10) {
        Toast.fire({
          icon: "Success",
          title: "Invalid Pan Number",
        });
        this.reloadCaptcha();
        this.loading = false;
        return false;
      }
      if (this.gst_no.length != 15) {
        Toast.fire({
          icon: "Success",
          title: "Invalid Gst Number",
        });
        this.reloadCaptcha();
        this.loading = false;
        return false;
      }
      if (this.panFile == null) {
        Toast.fire({
          icon: "Success",
          title: "Please upload your pan card",
        });
        this.reloadCaptcha();
        this.loading = false;
        return false;
      }
      
      //alert(parseInt(this.num1) + parseInt(this.num2));
      //alert(this.verify_captcha);
      if (parseInt(this.num1) + parseInt(this.num2) != this.verify_captcha) {
        Toast.fire({
          icon: "Success",
          title: "Total did not match",
        });
        this.reloadCaptcha();
        this.loading = false;
        return false;
      }
      const form = new FormData();
      form.append("first_name", this.name);
      form.append("company_name", this.company_name);
      form.append("primary_email", this.email);
      form.append("mobile_1", this.phone_no);
      form.append("password", this.password);
      form.append("password_confirm", this.password_confirm);
      form.append("role_id", this.role_id);
      form.append("pincode", this.pincode);
      form.append("pan_no", this.pan_no);
      form.append("gst_no", this.gst_no);
      form.append("address", this.address);
      form.append("lat", this.geocodes);
      form.append("panfile", this.panFile);
      form.append("uploaddoc[0][document_id]", "2");
      form.append("uploaddoc[1][document_id]", "11");
      form.append("gstfile", this.gstFile);

      API.post("/user/register", form).then((res) => {
        console.log(res.data);
        //return false;
        this.loading = false;
        if (res.data.status == 200) {
          Toast.fire({
            icon: "Error",
            title: res.data.messages,
          });
          this.$router.push(`/verify/${window.btoa(this.email)}`);
        } else {
          let errorText = "";
          let arrayFailed = [];
          if (typeof res.data.messages === "object") {
            arrayFailed = Object.entries(res.data.messages).map((arr) => ({
              fieldName: arr[0],
              message: arr[1],
            }));
            arrayFailed.forEach((val) => {
              errorText = errorText + val.message + "<br>";
            });
          } else {
            errorText = res.data.message;
          }

          Toast.fire({
            icon: "Error",
            title: errorText,
          });
        }
        this.reloadCaptcha();
      });
      // .catch((err) => {
      //   this.loading = false;
      //   Toast.fire({
      //     icon: "Error",
      //     title: err.response.data.message.error,
      //   });
      //   this.reloadCaptcha();
      // });
      //axios
    },
    handlePanFileUpload(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      //this.createImage(files[0]);
      this.panFile = files[0];
    },
    handleGstFileUpload(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      //this.createImage(files[0]);
      this.gstFile = files[0];
    },
  },
  components: {
    //Alert,
    Frontendlayout,
    VueSimpleSuggest
  },
};
</script>

<style></style>
